module.exports = __webpack_public_path__ + "media/assets_v3/images/auction-list-2-551121b810c8a3cda482bde467dbc907.png";